import axios from 'axios'
//import { API_URL } from '@/constants/config'
import { auth } from '@/plugins/auth'
import { i18n } from '../../i18n'
import settings from '../../../public/settings.json'

const API_URL = settings.wsPath

export const httpClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 80000,
})

const authToken = async (req) => {
  if (req && req.headers) {
    const token = await auth.getToken()
    req.headers.Authorization = `Bearer ${token}`
    req.headers['Accept-Language'] = i18n.locale
  }
  return req
}

httpClient.interceptors.request.use(authToken)
